import Cookie from 'js-cookie'

const User = 'user';

export function getUser(){
    // return window.localStorage.getItem(User)
    return Cookie.get(User);
}

export function setUser(info){
    return Cookie.set(User,info)
    // return window.localStorage.setItem(User,info)
}

export function removeUser(){
    // return window.localStorage.removeItem(User)
    return Cookie.remove(User)
}


// WEBPACK FOOTER //
// ./src/utils/user.js